import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "status-text" }

import { computed } from "vue";
import { getStatusColor } from "@/shared/utils/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusInline',
  props: {
    status: {},
    label: {},
    title: {}
  },
  setup(__props: any) {

const props = __props;

const statusClass = computed(() => getStatusColor(props.status || ""));
const displayText = computed(() => {
  if (props.label) return props.label;
  if (props.status === "cancel_request") return "cancellation";
  return props.status || "-";
});
const titleText = computed(() => props.title || displayText.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["status-inline text-capitalize", statusClass.value]),
    title: titleText.value
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("span", {
      class: "status-dot",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(displayText.value), 1)
  ], 10, _hoisted_1))
}
}

})